import { createContext, useContext, type ReactNode } from 'react'
import {
  useCreditEventStream,
  type CreditStreamStatus,
} from '@/api/hooks/credit/useCreditEventStream'

const CreditStreamContext = createContext<CreditStreamStatus>('idle')

/**
 * Opens one live credit SSE for the authenticated shell and exposes status
 * to AsOf / downline provenance. Give/take balance refreshes ride this stream.
 */
export function CreditStreamProvider({ children }: { children: ReactNode }) {
  const status = useCreditEventStream()
  return <CreditStreamContext.Provider value={status}>{children}</CreditStreamContext.Provider>
}

export function useCreditStreamStatus(): CreditStreamStatus {
  return useContext(CreditStreamContext)
}
